import { ReactNode } from "react";

export const getLabelMessageId = (props: {
  error?: boolean;
  message?: string | ReactNode;
  "aria-errormessage"?: string;
}) => {
  if (props["aria-errormessage"]) return props["aria-errormessage"];
  return props.error && typeof props.message === "string"
    ? props.message
    : undefined;
};
